import Image from '@react/shared/components/Image';
import cx from 'classnames';
import { string } from 'prop-types';
import React, { forwardRef } from 'react';
import Chevron from 'sly/icons/Chevron';
import { getAuthorPath } from 'sly/resourceCenter/helpers';
import Heading from 'sly/system/Heading';
import Link from 'sly/system/Link';

const WrittenBy = forwardRef((props) => {
  const { className } = props;

  return (
    <div
      {...props}
      className={cx(
        'font-l-m mb-s',
        'w-full uppercase tracking-[1px]',
        'text-slate-lighter-40 md:m-0',
        className || ''
      )}
      data-tp-id='gen-Block-47aadd3c-4fec-4cc4-b399-f13b8fd49bf2'
    />
  );
});

const AuthorPreview = ({
  path,
  alternativeText,
  firstName,
  fullName,
  shortDescription,
  slug,
}) => {
  const authorPagePath = getAuthorPath(slug);
  return (
    <>
      <div
        className='flex flex-wrap'
        data-tp-id='gen-Flex-8e6ec1d3-4725-405e-9dfe-8483dfbe00f3'
      >
        <WrittenBy className='block md:hidden'>written by:</WrittenBy>

        <div
          className='aspect-w-1 mr-s mb-l h-20 w-20 cursor-pointer overflow-hidden rounded-[50%] md:mr-l md:mb-0'
          data-tp-id='gen-Block-ce4df7fa-b329-4735-a565-a2f26a472eff'
        >
          <Link
            to={authorPagePath}
            data-tp-id='gen-Link-ce8fe1e7-da10-4a30-bb71-c1b3dacf9029'
          >
            <Image
              path={path}
              alt={alternativeText}
              sources={[80]}
              sizes='5rem'
              layout='fill'
              objectFit='cover'
              data-tp-id='gen-Image-2f7e596e-c876-4f34-89a4-2292f4f728d5'
            />
          </Link>
        </div>
        <div
          className='flex flex-col'
          data-tp-id='gen-Flex-4440071b-3c46-4d08-96dd-f3cd88b54fff'
        >
          <WrittenBy className='hidden md:block'>written by:</WrittenBy>

          <Link
            to={authorPagePath}
            className='text-slate-base decoration-slate-base'
            data-tp-id='gen-Link-ff547aa3-3dbc-45f7-ac39-32f863a05256'
          >
            <Heading
              as='h3'
              className='font-t-m my-auto mx-0 whitespace-nowrap !text-slate-base'
              data-tp-id='gen-Heading-7a1093aa-cb9e-4578-b716-5174187cc680'
            >
              {fullName}
            </Heading>
          </Link>
        </div>
      </div>
      <div
        className='md:ml-20 md:pl-l'
        data-tp-id='gen-Block-813a6fb7-98a1-4e17-bed3-74aa6202d79f'
      >
        <div
          className='font-b-m dynamic-editor mb-l'
          data-tp-id='gen-Block-797a9b10-3613-420c-bd1c-926cc9412c39'
          dangerouslySetInnerHTML={{ __html: shortDescription }}
        />
        <Link
          to={authorPagePath}
          data-tp-id='gen-Link-4dd70524-1763-4421-b9f8-5449a5ffd5f6'
        >
          {`View other articles written by ${firstName}`}
          <Chevron className='rotate-90' />
        </Link>
      </div>
    </>
  );
};

AuthorPreview.propTypes = {
  path: string,
  alternativeText: string,
  firstName: string,
  fullName: string,
  shortDescription: string,
  slug: string,
};

export default AuthorPreview;
